module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAABGCAYAAADb7SQ4AAAAs0lEQVRoge3ZK3JCQRAF0MPosAHWAZrC81kL0UiwYS+AZwGwG8BSEZloqijeG3Ov7O7qY9r14DkdqVlgjQm+fDZ3XPCDE5Ta2OKAWQeounOGY7UMntPRvBb6zLLgu2cU1gXjBvC4YNgAHpbXM90kcODAgQMHDhw4cODAgQMHDhw4cODAgQMHDhw4cODA78K3Bu694NoAvhTsG8D74u9bvusR3eH4f1wbrHDGowPsUXcvq+UXiCsY+6yoQZwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/tyre-red.png
// module id = 41
// module chunks = 0